// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card__container{padding:.5rem 1rem}.btn__delete__interesado{cursor:pointer}.container__contactSearch{border:1px solid #afadad;position:relative;padding:1.5rem;margin-top:1rem}.input__search--interesado{margin-top:1rem!important}", ""]);
// Exports
module.exports = exports;
